import { AdminWorkspaceRoles, Roles } from '~/data/user/role';
import { WorkspaceType } from '~/scenes/MyWorkspace/data';

import {
  MyWorkspaceWidgetNames,
  getRoleWidgets,
} from './components/Widgets/data/widgets';

export const MyWorkspaceUserSettingsKey = 'MY_WORKSPACE';
export const CompanyWorkspaceSettingsKey = 'COMPANY_WORKSPACE';
export const WorkspaceId_NO_WORKSPACE = 'NO_WORKSPACE';

export interface WidgetSize {
  w: number;
  h: number;
}

export interface WidgetSettings {
  id: string;
  widget: MyWorkspaceWidgetNames;
  size?: WidgetSize;
  title?: string;
  isVisible?: boolean;
  config?: object;
}

export interface WorkspaceSettings {
  id: string;
  name: string;
  widgets: WidgetSettings[];
  type: WorkspaceType | string;
  restrictToRoles: AdminWorkspaceRoles[];
}

export const getRolesDefaultWidgets = (role: Roles): WidgetSettings[] => {
  return getRoleWidgets(role).map((widgetName) => {
    return {
      id: widgetName,
      widget: widgetName,
      isVisible: true,
    };
  });
};
